import React, { useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import Header from "./Header";
import "./CompanyPages.css";

const Company = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return (
    <div className="home">
      <Header />
      <main className="wc-info">
        <div className="wc-info-container">
          <div className="wc-info-intro">
            <p className="wc-info-eyebrow">COMPANY</p>
            <h1>会社概要</h1>
            <p className="wc-info-lead">株式会社ワンダーコムズの基本情報をご案内します。</p>
          </div>
          <dl className="wc-info-company">
            <div><dt>会社名</dt><dd>株式会社ワンダーコムズ</dd></div>
            <div><dt>設立</dt><dd>2014年3月</dd></div>
            <div><dt>代表</dt><dd>矢田 寛</dd></div>
            <div><dt>事業内容</dt><dd>ソフトウェア開発</dd></div>
          </dl>
          <div className="wc-info-company-links">
            <Link className="wc-info-link" to="/service">サービスを見る<span aria-hidden="true">→</span></Link>
            <Link className="wc-info-link" to="/contact">お問い合わせ<span aria-hidden="true">→</span></Link>
          </div>
        </div>
      </main>
    </div>
  );
};

export default Company;
